import React, { Component } from 'react';


class Tabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: ""
        };
    }
    onChangeValue = (value) => {
        this.setState({ value: value })
    }
    add = (groupId, segmentId, value) => {
        this.setState({ value: '' })
        this.props.addPromotion(groupId, segmentId, value)
    }
    render() {
        let tabs = []
        this.props.tabs.map((item, key) => {
            this.props.compete.customerSegmentData.map(comp => {
                comp.segments.map(segments => {
                    if (item.groupId === comp.groupId && item.segmentId === segments.segmentId) {
                        tabs.push(
                            <li className="nav-item" key={`${item.groupId + `id` + item.segmentId}`} onClick={()=>this.props.onTabChange(key)}>
                                <a data-toggle="tab" className={key === this.props.tabStep ? "nav-link active show" : "nav-link"} href={`#${item.groupId + `id` + item.segmentId}`} aria-controls={`${item.groupId + `id` + item.segmentId}`} aria-selected="true">{comp.groupName + ` - ` + segments.name}</a>
                            </li>)
                    }
                })
            })

        });
        let tabsContent = this.props.tabs.map((tabItem, key) => {
            return (
                <div id={tabItem.groupId + `id` + tabItem.segmentId} className={key === this.props.tabStep ? "tab-pane fade show active tabContentdiv positioning-tab-content" : "tab-pane fade tabContentdiv compete-tab-content positioning-tab-content"} role="tabpanel" key={key}>
                    <div className="row">
                        <div className="col-md-6 col-lg-4">
                            <div className="row">
                                <div className='col-sm-12'>
                                    <div className='promotionAdd' style={{ width: "400px" }}>
                                        <label style={{marginBottom: "0"}}>Promotion</label>
                                        <div className="form-group" style={{marginBottom: "0", marginLeft: "10px", marginRight: "10px"}}>
                                            <input type="text" className='form-control'
                                                value={this.state.value}
                                                onChange={(e) => this.onChangeValue(e.target.value)}
                                                onKeyPress={(e) => { e.key === "Enter" && this.add(tabItem.groupId, tabItem.segmentId, this.state.value) }}
                                            />
                                        </div>
                                        <i className="fa fa-plus plusbtn plus-icon" onClick={(e) => this.add(tabItem.groupId, tabItem.segmentId, this.state.value)}></i>
                                        {/* <div className='btn btn-success' onClick={(e) => this.add(tabItem.groupId, tabItem.segmentId, this.state.value)} >Add</div> */}
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="customer-groups-list-content">
                                        {/* <ul>
                                            { */}
                                                {tabItem.promotion && tabItem.promotion.length > 0 && tabItem.promotion.map(promotion => {
                                                    return <div key={promotion.id} className="promotionValues">
                                                        <label><strong>{promotion.value}</strong></label>
                                                        <i className="fa fa-minus minus-icon" onClick={() => this.props.onDeletePromotion(tabItem.groupId, tabItem.segmentId, promotion.id)}></i>
                                                    </div>
                                                })}
                                            {/* }
                                        </ul> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-8">
                            <div className="value-props-image"></div>
                        </div> 
                    </div>
                </div>
            )

        })
        return (
            <div className='criteria-tabs-content attractiveness-tab-content'>
                <ul className="nav nav-tabs benefitsNavTabs" role="tablist" id="myTab">
                    {tabs}
                </ul>
                <div className="tab-content benefitsTabcontent" id="myTabContent" >
                    {tabsContent}
                </div>
            </div>
        )
    }
}

export default (Tabs);



// WEBPACK FOOTER //
// ./src/components/ValuePropositionComponent/Step4/Tabs/Tabs.jsx